var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M0 0.31L32 0.31L32 32L0 32L0 0.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.52 9.05C22.76 9.05 23 9.1 23.22 9.19C23.45 9.28 23.65 9.41 23.82 9.58C23.99 9.75 24.12 9.95 24.22 10.17C24.31 10.39 24.36 10.63 24.36 10.87L24.36 21.77C24.36 22.01 24.31 22.25 24.22 22.47C24.12 22.69 23.99 22.89 23.82 23.06C23.65 23.23 23.45 23.36 23.22 23.45C23 23.55 22.76 23.59 22.52 23.59L9.84 23.59C9.6 23.59 9.36 23.55 9.13 23.45C8.91 23.36 8.71 23.23 8.54 23.06C8.37 22.89 8.23 22.69 8.14 22.47C8.05 22.25 8 22.01 8 21.77L8 10.87C8 10.63 8.05 10.39 8.14 10.17C8.23 9.95 8.37 9.75 8.54 9.58C8.71 9.41 8.91 9.28 9.13 9.19C9.36 9.1 9.6 9.05 9.84 9.05L22.52 9.05ZM16.18 11.55C15.91 11.55 15.64 11.61 15.39 11.71C15.14 11.81 14.91 11.96 14.72 12.15C14.53 12.34 14.37 12.57 14.27 12.82C14.17 13.06 14.11 13.33 14.11 13.6C14.11 14.42 14.62 15.17 15.39 15.49C16.16 15.8 17.05 15.63 17.64 15.04C18.23 14.46 18.41 13.58 18.09 12.81C17.77 12.05 17.01 11.55 16.18 11.55ZM20.77 19.5C20.77 17.98 17.71 17.23 16.18 17.23C14.64 17.23 11.59 17.98 11.59 19.5L11.59 20.86L20.77 20.86L20.77 19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.86 20.61C26.3 20.61 25.86 20.17 25.86 19.62L25.86 12.69C25.86 12.14 26.3 11.7 26.86 11.7L26.86 11.7C27.41 11.7 27.86 12.14 27.86 12.69L27.86 19.62C27.86 20.17 27.41 20.61 26.86 20.61L26.86 20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21.3C4.95 21.3 4.5 20.85 4.5 20.31L4.5 13.37C4.5 12.83 4.95 12.38 5.5 12.38L5.5 12.38C6.05 12.38 6.5 12.83 6.5 13.37L6.5 20.31C6.5 20.85 6.05 21.3 5.5 21.3L5.5 21.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsActive);
export default __webpack_public_path__ + "static/media/contacts-active.923cbd61d25f8055d232f602535cc61a.svg";
export { ForwardRef as ReactComponent };